import { ReportSource } from '@geovelo-frontends/commons';

import { ReportSourceData } from '../../graphql-types';

export function parseReportSource({ id, code, url, title }: ReportSourceData): ReportSource | null {
  if (!code) return null;

  return new ReportSource(id || -1, code, url || '', title || '');
}
